module.exports = __webpack_public_path__ + "static/media/dx-zero-mobile-platform.3a578e35.png";